import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = ({
  inLayout = false,
  homePath = "/",
  homeLabel = "Go to Home",
}) => {
  const containerClass = inLayout
    ? "min-h-[60vh] flex items-center justify-center bg-background px-2 sm:px-6"
    : "min-h-screen flex items-center justify-center bg-background px-6";

  return (
    <div className={containerClass}>
      <div className="w-full max-w-lg text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-muted-foreground">
          404 Error
        </p>
        <h1 className="mt-4 text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-4 text-base text-muted-foreground">
          The page you are looking for does not exist or the URL is incorrect.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link
            to={homePath}
            className="inline-flex items-center rounded-md bg-primary text-white px-5 py-2.5 cursor-pointer text-sm transition-opacity hover:opacity-90"
          >
            {homeLabel}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
